<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <!-- <Tag color="orange" class="tag-ts">{{$t('role_ts')}}</Tag> -->
            <Form ref="form" :model="formData" :rules="rule" :label-width="130">
                <FormItem :label="$t('zh_cname')" prop="role_cname">
                    <Input v-model="formData.role_cname" :placeholder="$t('input')"></Input>
                </FormItem>
                <!-- <Row>
                    <Col span="12">
                        <FormItem :label="$t('role_cat')">
                            <Select v-model="cat_id" :disabled="!!formData.role_id" clearable :placeholder="$t('default_self')">
                                <Option v-for="(item, index) in cats" :value="item.key" :key="index">{{item.value}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('sort')" prop="sort_id">
                            <Input v-model="formData.sort_id" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row> -->
                <FormItem :label="$t('tw_cname')" prop="zh-tw_cname">
                    <Input v-model="formData['zh-tw_cname']" :placeholder="$t('input')"></Input>
                </FormItem>
                <FormItem :label="$t('en_cname')" prop="en_cname">
                    <Input v-model="formData.en_cname" :placeholder="$t('input')"></Input>
                </FormItem>
                <FormItem :label="$t('sort')" prop="sort_id">
                    <Input v-model="formData.sort_id" :placeholder="$t('input')"></Input>
                </FormItem>
                <Row v-if="!$base.isEmpty(this.item)">
                    <Col span="12"><FormItem :label="$t('add_user')"><Input v-model="item.add_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('add_time')"><Input v-model="item.add_time" disabled></Input></FormItem></Col>
                </Row>
                <Row v-if="!$base.isEmpty(this.item)">
                    <Col span="12"><FormItem :label="$t('upd_user')"><Input v-model="item.upd_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('upd_time')"><Input v-model="item.upd_time" disabled></Input></FormItem></Col>
                </Row>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                relist: false,
                formData: {
                    role_id:'',
                    role_cname: '',
                    sort_id: 99,
                    auth_flag:'0',
                    cat_id: '',
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                    en_cname:'',
                    'zh-tw_cname':''
                },
                cats: [],
                cat_id: '',
                rule: {
                    role_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    'zh-tw_cname': [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    en_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    sort_id: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                },
                item: {}
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            if(!this.$base.isEmpty(this.$base.getRequest().data)) {
                this.item = JSON.parse(this.$base.getRequest().data);
                this.formData.cat_id = this.item.cat_id
                this.formData.role_id = this.item.role_id
                this.formData.role_cname = this.item.role_cname
                this.formData.sort_id = this.item.sort_id
                this.formData.en_cname = this.item.en_cname
                this.formData['zh-tw_cname'] = this.item['zh-tw_cname']
                this.getInfo();
            }
            else {
                this.getLoad()
            }
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getLoad : function () {
                this.$base.showLoading();
                this.$request.sendPost("role/before-add",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cats = data.cats;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            getInfo: function(){
                var id = this.formData.role_id;
                var data = {
                    role_id: id
                };
                this.$base.showLoading();
                this.$request.sendPost("role/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cats = data.cats;
                        this.cat_id = this.formData.cat_id;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.formData.cat_id = this.cat_id || '';
                var url = this.$base.isEmpty(this.item) ? "role/add" : "role/upd";
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/role/role_save.vue